import * as React from 'react';

import { ESSAdapter, TypeaheadRenderType, UitkTypeahead } from 'uitk-react-typeahead';

import { useStores } from 'hooks';

import { IDestination, useSearchWidgetContext } from 'features/search-widget';

interface IDestinationTypeaheadProps {
  inputLabel: string;
  inputPlaceholder: string;
  resultsEmptyPlaceholder: string;
  destination: IDestination;
  onDestinationClear?(): void;
  onDestinationUpdate?(nextDestination: IDestination): void;
}

function DestinationTypeahead({
  inputLabel,
  inputPlaceholder,
  resultsEmptyPlaceholder,
  destination,
  onDestinationClear,
  onDestinationUpdate,
}: IDestinationTypeaheadProps): JSX.Element {
  const {
    app: { program },
  } = useStores();

  const { selectedLob } = useSearchWidgetContext();

  return (
    <UitkTypeahead
      adapter={
        new ESSAdapter({
          client: 'eg-search-widget',
          dest: true,
          domain: 'https://www.expedia.com/',
          expuserid: -1,
          features: 'contextual_ta|postal_code|multiregion_parent|ta_hierarchy|nearby_airport',
          guid: '',
          lob: selectedLob?.type,
          locale: program?.locale?.baseName || 'en_US', // Decides what language suggestions are returned in
          maxResults: 8,
          personalize: false,
          regionType: 2047, // All regions types + hotels (matches HOTELS lob)
          siteId: 1,
        })
      }
      id="destination-typeahead"
      stid="destination-typeahead"
      // className="destination__typeahead"
      name="destination"
      icon="place"
      label={inputLabel}
      value={destination?.term}
      typeaheadPlaceholder={inputPlaceholder}
      typeaheadEmptyResultPlaceholder={resultsEmptyPlaceholder}
      renderType={TypeaheadRenderType.DIALOG}
      allowExactMatch={true}
      hasClearButton={true}
      handleClear={onDestinationClear}
      onUpdate={onDestinationUpdate}
    />
  );
}

export { DestinationTypeahead };
